import {ITemplateDetailDefinition} from "@syginc/tellus-client";
import {LRUCache} from "lru-cache";

import {AdminApi} from "../../api/api";

// キャッシュキー
const templateDetailCacheKeyPrefix = "template-detail:";

// LRUキャッシュ（1分間有効）
const templateDetailCache = new LRUCache<string, Promise<ITemplateDetailDefinition>>({
    ttl: 60 * 1000,
    max: 100, // template 詳細のキャッシュ数を上限付きで管理し、メモリ肥大化を防ぐ
});

async function getTemplateDetailDefinitionsFromApi(
    adminApi: AdminApi,
    templateId: string,
): Promise<ITemplateDetailDefinition> {
    let mediaId = "";
    const segments = window.location.pathname.split("/");
    if (segments[1] === "admin" && segments.length >= 3) {
        // URLのパスからmediaIdを取得
        mediaId = segments[2];
    }

    const result = await adminApi.getTemplate({mediaId}, {templateId});
    return result;
}

export async function getTemplateDetailDefinitions(
    adminApi: AdminApi,
    templateId: string,
): Promise<ITemplateDetailDefinition> {
    const cacheKey = `${templateDetailCacheKeyPrefix}${templateId}`;
    const cacheEntry = templateDetailCache.get(cacheKey);

    if (cacheEntry) {
        console.log(`getTemplateDetail called, cache hit for templateId: ${templateId}`);
        return cacheEntry;
    }

    return cacheTemplateDetailDefinitions(adminApi, templateId);
}

export function cacheTemplateDetailDefinitions(
    adminApi: AdminApi,
    templateId: string,
): Promise<ITemplateDetailDefinition> {
    const result = getTemplateDetailDefinitionsFromApi(adminApi, templateId);
    const cacheKey = `${templateDetailCacheKeyPrefix}${templateId}`;
    templateDetailCache.set(cacheKey, result);
    return result;
}
